<div class="modal-header">
  <h4 class="modal-title">Email Opt-In Preview</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="form-group">
    <div class="form-check">
      <input class="form-check-input" type="checkbox"
             id="hasOptedInToMarketingInput"
             name="has_opted_in_to_marketing"
             [defaultChecked]="orgConfig.email_opt_in_is_selected_by_default">
      <label class="form-check-label" for="hasOptedInToMarketingInput"
             [innerHTML]="getRenderedCheckboxText()">
      </label>
    </div>
    <small class="form-text text-muted" *ngIf="orgConfig.email_opt_in_help_text"
           [innerHTML]="getRenderedHelpText()">
    </small>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
</div>
